export class DownTimeDashboardDateRequest{
  fromDate:any;
  toDate:any;    
}